import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styles from "./ProductsServicesPanel.module.css";

export default function ProductsCard({ products }) {
  const { t } = useTranslation("dashboard");
  const {
    numberOfWebsites,
    numberOfDomains,
    numberOfMobileApps,
    numberOfSubscriptions,
    subscriptionPlan,
  } = products;

  const subscriptionBadgeLabel =
    subscriptionPlan === "USERDASHBOARDBADGE"
      ? t("productsPanel.subscriptionBadge")
      : subscriptionPlan;

  return (
    <div className={styles.productsCard}>
      <div className={styles.header}>
        <h3 className={styles.title}>{t("productsPanel.title")}</h3>
        {subscriptionPlan && (
          <div className={styles.subscriptionBadge}>
            {subscriptionBadgeLabel}
          </div>
        )}
      </div>

      <div className={styles.statsGrid}>
        <Link
          to="/products"
          state={{ tab: "maintenance" }}
          className={styles.statItem}
        >
          <div className={styles.statIcon}>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <circle cx="12" cy="12" r="10" />
              <path d="M12 2a14.5 14.5 0 0 0 0 20a14.5 14.5 0 0 0 0-20" />
              <path d="M2 12h20" />
            </svg>
          </div>
          <div className={styles.statContent}>
            <div className={styles.statNumber}>{numberOfWebsites || 0}</div>
            <div className={styles.statLabel}>
              {t("productsPanel.websites")}
            </div>
          </div>
        </Link>

        <Link
          to="/products"
          state={{ tab: "maintenance" }}
          className={styles.statItem}
        >
          <div className={styles.statIcon}>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <rect x="5" y="2" width="14" height="20" rx="2" ry="2" />
              <line x1="12" y1="18" x2="12.01" y2="18" />
            </svg>
          </div>
          <div className={styles.statContent}>
            <div className={styles.statNumber}>{numberOfMobileApps || 0}</div>
            <div className={styles.statLabel}>
              {t("productsPanel.mobileApps")}
            </div>
          </div>
        </Link>

        <Link
          to="/products"
          state={{ tab: "domains" }}
          className={styles.statItem}
        >
          <div className={styles.statIcon}>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M9 12l2 2 4-4" />
              <path d="M21 12c-1 0-3-1-3-3s2-3 3-3 3 1 3 3-2 3-3 3" />
              <path d="M3 12c1 0 3-1 3-3s-2-3-3-3-3 1-3 3 2 3 3 3" />
              <path d="M12 3c0 1-1 3-3 3s-3-2-3-3 1-3 3-3 3 2 3 3" />
              <path d="M12 21c0-1 1-3 3-3s3 2 3 3-1 3-3 3-3-2-3-3" />
            </svg>
          </div>
          <div className={styles.statContent}>
            <div className={styles.statNumber}>{numberOfDomains || 0}</div>
            <div className={styles.statLabel}>{t("productsPanel.domains")}</div>
          </div>
        </Link>

        <Link
          to="/billing"
          state={{ tab: "plans" }}
          className={styles.statItem}
        >
          <div className={styles.statIcon}>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
            </svg>
          </div>
          <div className={styles.statContent}>
            <div className={styles.statNumber}>
              {numberOfSubscriptions || 0}
            </div>
            <div className={styles.statLabel}>
              {t("productsPanel.subscriptions")}
            </div>
          </div>
        </Link>
      </div>
    </div>
  );
}
